import React, { useState, useEffect } from 'react';
import commonUtil from '../../utils/commonUtil';

const EventIconWithLoader = ({
  event_id,
  event_icon,
  event_image,
  event_theme_color,
  icon_width,
  icon_height,
  multiple,
  hide_border,
}) => {
  const [imgLoaded, setImgLoaded] = useState(false);

  useEffect(() => {
    if (!event_image) {
      setImgLoaded(false);
    }
    if (event_image && !imgLoaded) {
      commonUtil.showApplicationLoader();
    }
  }, [event_image, imgLoaded]);

  const event_icon_content = event_icon?.content?.replace(
    '<svg',
    `<svg id="event-icon-${event_id}"`,
  );

  return (
    <div className='event-icon'>
      {!imgLoaded && event_icon_content && (
        <>
          <div dangerouslySetInnerHTML={{ __html: event_icon_content }} />
          <style>
            {`svg#event-icon-${event_id} {
              width: ${icon_width || '100%'};
              height: ${icon_height || '100%'};
              color: ${event_theme_color || '#333'};
            }`}
          </style>
        </>
      )}

      {event_image && (
        <img
          className={`${multiple ? 'multiple-card-image' : 'card-image'}`}
          style={{
            border: `2.5px solid ${event_theme_color && !hide_border ? event_theme_color : 'transparent'}`,
            borderRadius: '100%',
            width: icon_width || '100%',
            height: icon_height || '100%',
            objectFit: 'cover',
            display: imgLoaded ? 'block' : 'none',
          }}
          src={event_image}
          alt='Event Icon'
          onLoad={() => {
            commonUtil.hideApplicationLoader();
            setImgLoaded(true);
          }}
          onError={() => {
            commonUtil.hideApplicationLoader();
            setImgLoaded(false);
          }}
        />
      )}
    </div>
  );
};

export default EventIconWithLoader;
